$(document).ready(function(){

    $('.btn-register-collapse').on('click', function() {
        $(this).hide();
    });


    
});